/*  ========================================================================
    # Scripts - Location
    ========================================================================  */

/**
 * Generate the map for each location content block.
 */

const BlockLocation = {
  cfg: {
    mapContainers: document.querySelectorAll('.google-map-container'),
    locations: []
  },

  initMap(location) {
    location.map = new google.maps.Map(location.container, {
      mapTypeId: 'roadmap',
      disableDefaultUI: true,
      zoom: 12,
      center: {
        lat: location.lat,
        lng: location.lng
      }
    });
  },

  createMarker(location) {
    location.marker = new google.maps.Marker({
      map: location.map,
      icon: '/wp-content/themes/theaterkoblenz-ganzohr/dist/images/misc/map-pin.png',
      position: {
        lat: location.lat,
        lng: location.lng
      }
    });
  },

  locations() {
    this.cfg.mapContainers.forEach(container => {
      const locationObject = {
        container,
        lat: parseFloat(container.dataset.lat, 10),
        lng: parseFloat(container.dataset.lng, 10),
        map: null,
        marker: null
      };

      this.initMap(locationObject);
      this.createMarker(locationObject);

      this.cfg.locations.push(locationObject);
    });
  },

  init() {
    if (typeof this.cfg.mapContainers !== 'undefined' && this.cfg.mapContainers !== null) {
      this.locations();
    }
  }
};

export default BlockLocation;
